<template>
<ul class='result'>
  <!--{{publications}}-->
      <template v-for="(publication, i) in publications">
          <li class='record' :key='i'><div class="citation-js cite" :data-input='cslJson(publication)' data-output-lang="en-US"  _data-output-style="outputStyle" data-output-style="citation-chicago-author-date" data-output-template-url="" _data-output-template-url="outputTemplate"></div></li>
        <!-- {{genCitation(publication)}} -->
        <!-- <li :key="publication.id"> <text-highlight :queries="hightLightExpands(keyword.replace(/[+.,/#!$%^&*:{}=\-_`~()ʻ“]/g,'').split(' '))" :caseSensitive="false">{{publication.title_text_cjk.join('') }}</text-highlight></li> -->
      </template>      
    </ul>
</template>

<script>


  export default {
    name: 'recordList',
    props: ['publications'],
    data: function (){
      return {
        TITLE : 'title_text_cjk',
 AUTHOR : 'author-editor-or-organization_ss',
 YEAR : 'year-derived_s',
 PUBLISHER : 'publisher_s',
 VOLUME : 'volume_s',
 PLACE : 'place-of-publication_s',
 PERIOD : 'series_s',
 REF_TYPE : 'reference-type_s',
 REF : 'ref_ss',
 PAGE : 'page-range_s'
      }
    },
    methods: {
      cslJson (pub) {
        // console.log(pub)
        let _item = pub
        let type = "";
      
      switch(_item[this.REF_TYPE]){
        case "Audio or Video Document":
           type= "article";
           break;
        case "Book":
           type= "book";
           break;
        case "Book, Edited":
           type= "book";
           break;
        case "Collected Work":
           type= "article";
           break;
        case "Conference Proceedings":
           type= "paper-conference";
           break;
        case "Contribution in…":
           type= "article";
           break;
        case "Internet Document":
           type= "webpage";
           break;
        case "Journal Article":
           type= "article-journal";
           break;
        case "Lecture":
           type= "article";
           break;
        case "Manuscript":
           type= "manuscript";
           break;
        case "Movie":
           type= "motion_picture";
           break;
        case "Musical Work / Music Album":
           type= "song";
           break;
        case "Report or Gray Literature":
           type= "article";
           break;
        case "Special Issue":
           type= "article";
           break;
        case "Thesis":
           type= "thesis";
           break;
      }
      
      // console.log(pub)
      
      var result = {
    type: type || '',
    title: _item[this.TITLE],
    author:[],
//     author: [
//       {
// 	given: "H. K.",
// 	family: "Hall"
//       }
//     ],
    issued: { 'raw': _item[this.YEAR] || '' } ,
    // issued: [],
    // containerTitle: _item.Series,
    // edition:_item.Edition || '',
    // ISBN: _item.ISBN || '',
    publisher: _item[this.PUBLISHER] ? _item[this.PUBLISHER] : '',
    issue:_item.Number|| '',
    volume: _item[this.VOLUME]|| '',
    page: _item[this.PAGE]|| '',
  }
  result['container-title']=_item[this.PERIOD] || '';
  result['publisher-place']=_item[this.PLACE] || '';

  _item[this.AUTHOR].reduce((acc, name)=>{
    let name_components = name.split(',')
    acc.push({
      family: name_components[0],
      given: name_components[1] || ''
    })
    return acc
  },
  result['author']
  )

  // for (let i=0; i < _item.author-editor-or-organization_ss.length; i++){
  //   let name_components = _item.author-editor-or-organization_ss[i].split(',');
    
  //   result['author'].push({
  //     family: name_components[0],
  //     given: name_components[1] || ''
  //   })
  // }
//   for (var i=0; i < _item.Year_indexed.length; i++){
//     var obj = {raw:_item.Year_derived};
//     result.issued.push({
// 	"date-parts": [ "1957", "1", "1" ]
//       });
//   }
  
  // console.log(result);
      return JSON.stringify(result);
      },
}
}
</script>
<style scoped>
ul {
  color: #000022;
  list-style:none !important;
  padding-left: 0px;
}
</style>
<style scoped>
  ul.result {
  color: #000022;
  list-style:none !important;
  padding-left: 0px;
}
.result li {
    padding: 0.3em 0.5em 1em;
}

.result li.year {
  font-weight: bold;
  background-color: white; 
  border-style: solid; 
  border-width: 0px 2px 1px 0px; 
  margin-top: 20px; 
  margin-bottom: 20px;
}

.result li.record:nth-child(odd) {
    background: #fff none repeat scroll 0 0;
}
.result li.record:nth-child(even) {
    background: #f2f6fa none repeat scroll 0 0;
}
</style>